import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { LoadingSpinner } from '../../components/LoadingSpinner';
import Column from './ChartColumn';
import Bar from './ChartBar';
import Line from './ChartLine';
import Pie from './ChartPie';
import {
  parseColumnData,
  parseBarData,
  parseLineData,
  parsePieData
} from './parsers';
import { CustomWidth, CustomHeight } from './styles';

const ChartComponent = ({
  active,
  data,
  fields,
  loading,
  rendered,
  TableComponent,
  ...props
}) => {
  if (loading && active !== 'charts-table') {
    return (
      <div className="tvt-report-builder__spinner">
        <LoadingSpinner />
      </div>
    );
  }
  if (active !== 'charts-table' && !rendered)
    return (
      <div className="tvt-empty-report__dnd-wrapper full-height">
        <p>Run to view the chart</p>
      </div>
    );
  switch (active) {
    case 'charts-table':
      return <TableComponent />;
    case 'charts-column': {
      const parsedProps = parseColumnData(fields, data);
      return (
        <div className="scroll-horizontal">
          <CustomWidth
            elements={parsedProps.data.length}
            spacing={40}
            minimum={1400}
          >
            <Column {...parsedProps} {...props} />
          </CustomWidth>
        </div>
      );
    }
    case 'charts-bar': {
      const parsedProps = parseBarData(fields, data);
      return (
        <div className="scroll-vertical">
          <CustomHeight
            elements={parsedProps.data.length}
            spacing={25}
            minimum={637}
          >
            <Bar {...parsedProps} {...props} />
          </CustomHeight>
        </div>
      );
    }
    case 'charts-line': {
      const parsedProps = parseLineData(fields, data);
      return (
        <div className="scroll-horizontal">
          <CustomWidth
            elements={parsedProps.data.length}
            spacing={50}
            minimum={1400}
          >
            <Line {...parsedProps} {...props} />
          </CustomWidth>
        </div>
      );
    }
    case 'charts-pie': {
      const parsedProps = parsePieData(fields, data);
      return <Pie {...parsedProps} {...props} />;
    }
    default:
      return null;
  }
};

ChartComponent.propTypes = {
  active: PropTypes.string,
  data: PropTypes.array, // eslint-disable-line
  fields: PropTypes.array, // eslint-disable-line
  loading: PropTypes.bool,
  rendered: PropTypes.bool,
  TableComponent: PropTypes.oneOfType([PropTypes.node, PropTypes.func])
    .isRequired
};

ChartComponent.defaultProps = {
  active: 'charts-table',
  data: [],
  fields: [],
  loading: false,
  rendered: false
};

const Chart = props => {
  const wrapperClassName = classnames('tvt-chart', {
    'auto-height': props.active === 'charts-table'
  });
  return (
    <div className={wrapperClassName}>
      <ChartComponent {...props} />
    </div>
  );
};

Chart.propTypes = {
  active: PropTypes.string,
  data: PropTypes.array // eslint-disable-line
};

Chart.defaultProps = {
  active: 'charts-table'
};

export default Chart;
